import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        colorMode: { default: 'info' },
        flash: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(['badge', 'badge-pill', `badge-${props.colorMode}`, props.flash && 'badge-flush'].filter(Boolean))
            }, null, 2));
        };
    }
});
